import DetailsGridColumns from '@components/shared/DetailsGridColumns';
import DetailsGridRows from '@components/shared/DetailsGridRows';
import { PAYOUT_METHOD } from '@constant/steps';
import { TransferDetailsContext } from '@context/TransferDetailsContext';
import { Divider, Grid, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
	subtitle: {
		color: theme.text.tertiary,
		fontWeight: '700',
		fontSize: '0.75rem'
	},
	content: {
		color: theme.text.primary,
		fontWeight: '700',
		fontSize: '0.875rem'
	},
	contentLight: {
		color: theme.text.primary,
		fontWeight: '600',
		fontSize: '0.875rem'
	}
}));

const getCountryCurrency = (details, t, classes) => {
	return [
		...(details?.recipient?.countryName
			? [
					{
						subTitle: t('COUNTRY'),
						content: details?.recipient?.countryName,
						subtitleClassName: classes.subtitle,
						contentClassName: classes.contentLight
					}
				]
			: []),
		...(details?.recipient?.currencyName && details?.recipient?.currencyCode
			? [
					{
						subTitle: t('CURRENCY'),
						content: `${details?.recipient?.currencyName} (${details?.recipient?.currencyCode})`,
						subtitleClassName: classes.subtitle,
						contentClassName: classes.content
					}
				]
			: [])
	];
};

const getRecipientDetails = (details, t, classes) => {
	const payoutMethod = PAYOUT_METHOD[details?.transaction?.payoutMethod?.toUpperCase()];
	return [
		...(details?.recipient?.fullName
			? [
					{
						subTitle: t('NAME'),
						content: details?.recipient?.fullName,
						subtitleClassName: classes.subtitle,
						contentClassName: classes.contentLight
					}
				]
			: []),
		...(payoutMethod !== PAYOUT_METHOD.CASH_PICKUP && details?.recipient?.nativeName
			? [
					{
						subTitle: t('NATIVE_NAME'),
						content: details?.recipient?.nativeName,
						subtitleClassName: classes.subtitle,
						contentClassName: classes.contentLight
					}
				]
			: []),
		...(details?.recipient?.accountNo
			? [
					{
						subTitle: payoutMethod === PAYOUT_METHOD.BANK_ACCOUNT ? t('BANK_ACCOUNT_NUMBER') : t('DIGITAL_WALLET_ID'),
						content: details?.recipient?.accountNo?.match(/.{1,4}/g).join(' '),
						subtitleClassName: classes.subtitle,
						contentClassName: classes.content
					}
				]
			: []),
		...(details?.recipient?.accountName
			? [
					{
						subTitle: payoutMethod === PAYOUT_METHOD.BANK_ACCOUNT ? t('BANK_NAME') : t('DIGITAL_WALLET_PROVIDER'),
						content: details?.recipient?.accountName,
						subtitleClassName: classes.subtitle,
						contentClassName: classes.content
					}
				]
			: [])
	];
};

const RecipientDetails = () => {
	const theme = useTheme();
	const { t } = useTranslation();
	const { classes } = useStyles();
	const { details }: any = useContext(TransferDetailsContext);

	return (
		<>
			<Grid container direction="column">
				<Grid item>
					<Typography variant="h6" pb="5px" color={theme.text.secondary} sx={{ fontSize: '0.75rem' }}>
						{t('RECIPIENT_DETAILS')}
					</Typography>
				</Grid>
				<Divider />
				<Grid item pt="16px" pb="16px">
					<Grid container direction="column" spacing={1}>
						<DetailsGridColumns data={getCountryCurrency(details, t, classes)} />
					</Grid>
				</Grid>
				<Divider />
				<Grid item pt="16px">
					<Grid container direction="row">
						<DetailsGridRows data={getRecipientDetails(details, t, classes)} gridSize={12} containerSpacing={2} />
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};

export default RecipientDetails;
